import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { AuthContextProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import AppWithAuth from "./AppWithAuth";

const theme = createTheme({
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LanguageProvider>
        {" "}
        {/* Agregamos el LanguageProvider */}
        <AuthContextProvider>
          <AppWithAuth />
        </AuthContextProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
